import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Button, Flex, message, Modal } from 'antd'
import { StakingTokenConfigItem } from 'Modules'
import { useState } from 'react'

import { AppAdmin } from 'api/app-admin'
import { logError } from 'utils/logger'

interface ModalDeleteProps {
  open: boolean
  config: StakingTokenConfigItem | null
  onClose: () => void
  onSuccess: () => void
}

const ModalDelete = ({ open, config, onClose, onSuccess }: ModalDeleteProps) => {
  const [loading, setLoading] = useState(false)

  const handleDelete = async () => {
    if (!config) return
    try {
      setLoading(true)
      const res = await AppAdmin.deleteStakingTokenConfig(config._id)
      message.success(res?.data?.message || 'Config deleted successfully')

      onSuccess()
      onClose()
    } catch (error: any) {
      message.error(error?.message || 'Failed to delete config')
      logError('Error: ', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      open={open}
      title={
        <Flex gap={8} align="start">
          <ExclamationCircleOutlined style={{ color: '#faad14', fontSize: 20, marginTop: 2 }} />
          <Flex vertical>
            <div>Delete Config</div>
            <div style={{ fontSize: 12, color: '#6a7282', fontWeight: 400 }}>
              This action cannot be undone
            </div>
          </Flex>
        </Flex>
      }
      onOk={handleDelete}
      onCancel={onClose}
      confirmLoading={loading}
      closable={!loading}
      maskClosable={!loading}
      footer={() => (
        <>
          <Button disabled={loading} onClick={onClose}>
            Cancel
          </Button>
          <Button color="danger" variant="solid" loading={loading} onClick={handleDelete}>
            Delete
          </Button>
        </>
      )}
      centered
      destroyOnClose
    >
      Are you sure you want to delete config <strong>{config?.name}</strong>?
    </Modal>
  )
}

export default ModalDelete
